// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sr_a bhb_b bhb_bj","SubscribedPhotoblogs__link":"sr_b bhb_a bhb_r"};